import Box from '@mui/material/Box'
import { CSSProperties, ReactNode } from 'react'

interface Props {
  style?: CSSProperties
  children: ReactNode
}
export default function ActionContainer(props: Props) {
  return (
    <Box
      style={{
        ...containerStyle,
        ...props.style,
      }}
    >
      {props.children}
    </Box>
  )
}

const containerStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
}
